import { useEffect, useRef, useState } from 'react';

export const useFullScreen = () => {
    const fullScreenWrapperRef = useRef<HTMLDivElement>(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const onFullscreenChange = () => {
        if (fullScreenWrapperRef.current) {
            if (!document.fullscreenElement) {
                fullScreenWrapperRef.current.requestFullscreen();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };
    useEffect(() => {
        const onFsChange = () => {
            setIsFullscreen(Boolean(document.fullscreenElement));
        };
        document.addEventListener('fullscreenchange', onFsChange);
        return () => document.removeEventListener('fullscreenchange', onFsChange);
    }, []);

    return { isFullscreen, onFullscreenChange, fullScreenWrapperRef };
};
